// import $ from 'jquery';
const accordionInit = () => {
	const accordions = document.querySelectorAll( '.accordion-panel' );

	const openAccordion = ( accordion, controls, content ) => {
		const btn = accordion.querySelector( `[aria-controls=${ controls }]` );
		accordion.classList.add( 'accordion-active' );
		btn.setAttribute( 'aria-expanded', 'true' );
		content.setAttribute( 'aria-hidden', 'false' );
		content.style.maxHeight = `${ content.scrollHeight + 30 }px`;
	};

	const closeAccordion = ( accordion, controls, content ) => {
		const btn = accordion.querySelector( `[aria-controls=${ controls }]` );
		accordion.classList.remove( 'accordion-active' );
		btn.setAttribute( 'aria-expanded', 'false' );
		content.setAttribute( 'aria-hidden', 'true' );
		content.style.maxHeight = null;
	};

	const resetAllBoxes = ( accordions ) => {
		accordions.forEach( ( accordion ) => {
			const theIntro = accordion.querySelector( '.accordion-trigger' );
			const theControls = theIntro.getAttribute( 'aria-controls' );
			const theContent = document.getElementById( theControls );
			closeAccordion( accordion, theControls, theContent );
		} );
	};

	accordions.forEach( ( accordion ) => {
		const intro = accordion.querySelector( '.accordion-trigger' );
		const controls = intro.getAttribute( 'aria-controls' );
		const content = document.getElementById( controls );
		intro.onclick = () => {
			if ( content.style.maxHeight ) {
				closeAccordion( accordion, controls, content );
			} else {
				resetAllBoxes( accordions );
				openAccordion( accordion, controls, content );
			}
		};
	} );
};

export default accordionInit;
